import { Injectable } from '@angular/core';
import { IRequestId, IRequestString } from './../domain/id.entity';

@Injectable({
  providedIn: 'root',
})
export class RequestMakerHelpers {

  getIRequestIdEncrypted(id: number): IRequestId {
    return {
      id: id,
      encrypted: true,
    };
  }

  getIRequestStringEncrypted(value: string): IRequestString {
    return {
      value: value,
      encrypted: true,
    };
  }
}
